import { BASE_URL_CUSTOM_REST, BASE_URL_IMG, BASE_URL_TO_REPLACE } from "components/shared/constants";

export function replaceFullImageURL(data: any[]) {
  // Iterate through each image object in the "images" array

  data.forEach((item) => {
    // Replace  the substring in array's root inside "fullImage" property
    item.fullImage = item.fullImage.replace("/dx/api/dam/custom/", BASE_URL_IMG + BASE_URL_CUSTOM_REST);
    item.fullImage = item.fullImage.replace("normal", "default");

    // images sub array
    item.images.forEach((image: any) => {
      // Replace the substring in "fullImage" property
      image.fullImage = image.fullImage.replace(BASE_URL_TO_REPLACE, BASE_URL_IMG + BASE_URL_CUSTOM_REST);

      // Replace the substring in "thumbnail" property
      image.thumbnail = image.thumbnail.replace(BASE_URL_TO_REPLACE, BASE_URL_IMG + BASE_URL_CUSTOM_REST);

      // Replace the substring normal to default in fullImage property
      if (image.fullImage.includes("normal")) {
        image.fullImage = image.fullImage.replace("normal", "default");
        image.fullImage = image.fullImage.replace("/images", "/ExtendedSitesCatalogAssetStore/images");
      }
    });
  });
}

export function replaceFullThumbnailURL(data) {
  const object = { ...data };
  object.thumbnail = object.thumbnail.replace("/dx/api/dam/custom/", BASE_URL_IMG + BASE_URL_CUSTOM_REST);
}

export function replaceFullImageFieldPLP(obj: any[]) {
  if (obj.length > 0) {
    obj.forEach((item) => {
      // Replace  the substring in array's root inside "fullImage" property
      item.fullImage = item.fullImage.replace(
        "/dx/api/dam/custom/ExtendedSitesCatalogAssetStore/",
        BASE_URL_IMG + BASE_URL_CUSTOM_REST
      );
      item.fullImage = item.fullImage.replace("zoom", "default");

      item.thumbnail = item.thumbnail.replace(
        "/dx/api/dam/custom/ExtendedSitesCatalogAssetStore/",
        BASE_URL_IMG + BASE_URL_CUSTOM_REST
      );

      if (item.fullImage.includes("normal")) {
        item.fullImage = item.fullImage.replace("normal", "default");
        item.fullImage = item.fullImage.replace("/images", "/ExtendedSitesCatalogAssetStore/images");
      }
    });
  }
}

export function updateURLsInProductRecomendationCarousel(obj: any) {
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      updateURLsInProductRecomendationCarousel(obj[i]);
    }
  } else if (typeof obj === "object" && obj !== null) {
    // Check if the object has a "thumbnail" or "fullImage" property and update the URLs accordingly
    //*Saved if needed in future
    if (obj.thumbnail) {
      obj.thumbnail = obj.thumbnail.replace(
        "/dx/api/dam/custom/ExtendedSitesCatalogAssetStore/",
        `${BASE_URL_IMG}${BASE_URL_CUSTOM_REST}ExtendedSitesCatalogAssetStore/`
      );
      obj.thumbnail = obj.thumbnail.replace("thumbnail", "default");
    }
    //*Saved if needed in future
    // if (obj.fullImage) {
    //   obj.fullImage = obj.fullImage.replace(
    //     "/dx/api/dam/custom/ExtendedSitesCatalogAssetStore/",
    //     "https://dpjye2wk9gi5z.cloudfront.net/wcsstore/"
    //   );
    //   obj.fullImage = obj.fullImage.replace(
    //     "thumbnail",
    //     "default"
    //   );
    // }

    for (const key in obj) {
      updateURLsInProductRecomendationCarousel(obj[key]);
    }
  }
}

export function convertToTitleCase(str: string): string {
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getDpvaleBalanceCookie(name: string) {
  const nameLenPlus = (name.length + 1);
  const balance = document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
    return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
        const balance = decodeURIComponent(cookie.substring(nameLenPlus));
        const balanceParts = parseFloat(balance).toFixed(2).split(".");
        const formattedPrice = balanceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (balanceParts[1] ? "." + balanceParts[1] : "");
        return formattedPrice;
    })[0] || undefined;

  return balance;
}

export function getDpvaleRawBalanceCookie(name: string) {
  const nameLenPlus = (name.length + 1);
  const balance = document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
    return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
        const balance = decodeURIComponent(cookie.substring(nameLenPlus));
        const floatBalance = parseFloat(balance).toFixed(2);
        return floatBalance;
    })[0] || undefined;

  return balance;
}

export function getDistributorIDCookie(name: string) {
  const nameLenPlus = (name.length + 1);
  const distributorIdCookie = document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
      return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
       const distributorID = decodeURIComponent(cookie.substring(nameLenPlus));
       return distributorID;
    })[0] || undefined;

  return distributorIdCookie;
}